import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IContentManagementAppState } from '../../../App.types';
import { requestIsAdmin } from './IsAdmin.actions';
import { IsAdminReducerName } from './IsAdmin.reducer';

export function useIsAdmin(): boolean {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(requestIsAdmin());
    }, []);

    const state = useSelector((appState: IContentManagementAppState) => appState[IsAdminReducerName]);

    return state.isAdmin;
}
